var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVietnam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C24.8366 32.4189 32 25.2555 32 16.4189C32 7.58239 24.8366 0.418945 16 0.418945C7.16344 0.418945 0 7.58239 0 16.4189C0 25.2555 7.16344 32.4189 16 32.4189Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 8.76636L17.7261 14.0807H23.3139L18.7932 17.365L20.5199 22.6794L15.9993 19.395L11.4787 22.6794L13.2054 17.365L8.68481 14.0807H14.2726L15.9993 8.76636Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnam);
export default __webpack_public_path__ + "static/media/vietnam.c18a13d5.svg";
export { ForwardRef as ReactComponent };